export default __webpack_public_path__ + "static/media/cover.66dae5f6.png";